export function formatTableColumnLabel(
  label: string,
  preserveLabel = false,
): string {
  if (preserveLabel) return label;

  return label.replace(/\b[A-Z][a-z]+\b/g, (word, index) =>
    index === 0 ? word : word.toLowerCase(),
  );
}
